// ISO 3166-1 alpha-2
// ⚠️ No support for IE 11
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-underscore-dangle */

import {
  Address,
  Competitor,
  Member,
  TableWorker,
} from '../common-types/schema-types';

/**
 *
 * @param isoCode isoCode del país
 * @returns El código de la bandera del país
 */
export function countryToFlag(isoCode: string) {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode
        .toUpperCase()
        .replace(/./g, (char) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
        )
    : isoCode;
}

/**
 *
 * @param month Mes en ingles a traducir
 * @returns Mes traducido al español
 */
function translateMonth(month: string) {
  switch (month) {
    case 'Jan':
      return 'Enero';
    case 'Feb':
      return 'Febrero';
    case 'Mar':
      return 'Marzo';
    case 'Apr':
      return 'Abril';
    case 'May':
      return 'Mayo';
    case 'Jun':
      return 'Junio';
    case 'Jul':
      return 'Julio';
    case 'Aug':
      return 'Agosto';
    case 'Sep':
      return 'Septiembre';
    case 'Oct':
      return 'Octubre';
    case 'Nov':
      return 'Noviembre';
    case 'Dec':
      return 'Diciembre';
    default:
      return '';
  }
}

function interpretDay(dayAbreviation: string) {
  switch (dayAbreviation) {
    case 'Mon':
      return 'Lunes';

    case 'Tue':
      return 'Martes';

    case 'Wed':
      return 'Miercoles';

    case 'Thu':
      return 'Jueves';

    case 'Fri':
      return 'Viernes';

    case 'Sat':
      return 'Sábado';

    case 'Sun':
      return 'Domingo';

    default:
      return '';
  }
}

/**
 * Traduce al español el día y el mes pasado.
 * @param day Día a traducit
 * @param month Mes a traducir
 */
function translateDayAndMonth(day: string, month: string) {
  return [interpretDay(day), translateMonth(month)];
}

/**
 * Convierte una fecha en un string humanamente legible
 * @param date Fecha en formato string
 */
export function getFormatedDate(date: string) {
  const stringAsDate = new Date(date);
  const [day, month, dayNumber, year] = stringAsDate.toDateString().split(` `);
  const [translatedDay, translatedMonth] = translateDayAndMonth(day, month);
  return `${translatedDay} ${dayNumber} de ${translatedMonth} del ${year}`;
}

/**
 * Funcion helper para renderizar los datos de vivienda de una persona incluyendo
 * el país, departamento y ciudad.
 * @param address Lugar donde reside un participante
 * @returns Retorna formateado el país, departamento y ciudad
 */
export const renderAddress = (address: Address): string => {
  const {country, state, city} = address;
  return `${country}, ${state}, ${city}`;
};

export function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
// Fixme: Why? Move it to the component that use it.
export const renderErrorMessage = (error: firebase.default.auth.Error) => {
  switch (error.message) {
    case 'EMAIL_EXISTS':
      return `Ya existe un usuario con éste correo`;
    default:
      return `Hubo un error al crear el regsitro`;
  }
};

export const fieldRegistered = (field: string) =>
  `Este ${field} ya fue registrado`;

export const retrieveMemberNames = (competitors: Competitor[]) => {
  if (!competitors) return '';
  // return competitors
  //   .map((competitor) =>
  //     competitor?.members?.map((member) => {
  //       return `${competitor.groupNumber}=> ${competitor.matchDifference}:
  //       ${member.fullName}
  //       (${competitor.partners},"${member.clubId}",
  //         ${member.address.country},${member.address.state},${member.address.city})`;
  //     })
  //   )
  //   .join(',');
  return competitors
    .map((competitor) => competitor?.members?.map((member) => member.fullName))
    .join(',');
};

const cleanMembersTypename = (members: Member[]) => {
  return members.map((member) => {
    const {__typename, ...rest} = member;
    const {__typename: __typename2, ...cleanedAddress} = rest.address;
    rest.address = cleanedAddress;
    return rest;
  });
};

// Clean the typename of the competitor object since we are not using it
// and it's causing us issues when trying to serialize the object and update the store.
const cleanCompetitorTypename = (competitors: Competitor[]) => {
  return competitors.map((competitor) => {
    const competitorCopy = {...competitor};
    const {__typename, ...cleanedCompetitor} = competitorCopy;

    cleanedCompetitor.members = cleanMembersTypename(cleanedCompetitor.members);

    cleanedCompetitor.rounds = cleanedCompetitor.rounds.map((round) => {
      const objCopy = {...round};
      const {__typename: typename1, ...cleanedRound} = objCopy;
      const {competitorOne, competitorTwo} = cleanedRound;

      const {__typename: typename2, ...cleaneadCompetitorOne} = competitorOne;
      const {__typename: typename3, ...cleaneadCompetitorTwo} = competitorTwo;

      cleanedRound.competitorOne = cleaneadCompetitorOne;
      cleanedRound.competitorTwo = cleaneadCompetitorTwo;

      return cleanedRound;
    });

    return cleanedCompetitor;
  });
};

/**
 * @description Note for other developers on this method.
 * This ugly clean is because of the __typename that today (21/05/2021) Apollo Client
 * adds to make the cache work propertly. You can find the issue thread just right here
 * https://github.com/apollographql/apollo-feature-requests/issues/6
 *
 * Please consider change this solution once the library release a better wait to do it
 * @param tables Object table to clear typenames
 * @returns
 */
export const cleanTablesTypenames = (tables: TableWorker[]) => {
  const cleaneadObject: TableWorker[] = tables.map((table) => {
    const tableCopy = {...table};
    tableCopy.competitorOne = cleanCompetitorTypename(tableCopy.competitorOne);
    tableCopy.competitorTwo = cleanCompetitorTypename(tableCopy.competitorTwo);
    return tableCopy;
  });
  return cleaneadObject;
};
